export default __webpack_public_path__ + "media/verification/title_locale_sv-79d6740f.png";